module.exports = __webpack_public_path__ + "678c9293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/feature_lightbox3.png
// module id = 1521
// module chunks = 0